import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-documents-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-documents-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SaLongDatePipe } from "../../../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { ApplicationViewService } from "../../application-view.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { AppConfig } from "../../../../app.config";
import { ApiAttachmentConstants } from "../../../../shared/constants/api-constants/api-attachment.constants";
import { EditDocumentsDialogConstants } from "./edit-documents-dialog.constants";
import { FileUtils } from "src/app/shared/utils/file-utils";
import { FileService } from "../../../../shared/services/file/file.service";
let EditDocumentsDialogComponent = class EditDocumentsDialogComponent {
    activeModal;
    appControllerService;
    userInformationService;
    requestStatusService;
    applicationViewService;
    fileUploadService;
    saLongDatePipe;
    editDocumentForm;
    documentTypes = [];
    dialogTitle = "";
    documentToEdit;
    configUploadSettings;
    currentApplication;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    documentTypeLabel = EditDocumentsDialogConstants.DOCUMENT_TYPE_LABEL;
    descriptionLabel = EditDocumentsDialogConstants.DESCRIPTION_LABEL;
    fileLabel = EditDocumentsDialogConstants.FILE_LABEL;
    selectFileLabel = EditDocumentsDialogConstants.SELECT_FILE_LABEL;
    cancelBtnPlaceholder = EditDocumentsDialogConstants.CANCEL_BTN_PLACEHOLDER;
    documentTypeFormControlName = EditDocumentsDialogConstants.DOCUMENT_TYPE_FORM_CONTROL;
    descriptionFormControlName = EditDocumentsDialogConstants.DESCRIPTION_FORM_CONTROL;
    saveBtnPlaceholder = "Save";
    uploadedFiles = [];
    documentTypeErrMsg = EditDocumentsDialogConstants.DOCUMENT_TYPE_ERR_MSG;
    descriptionErrMsg = EditDocumentsDialogConstants.DESCRIPTION_ERR_MSG;
    noFileUploadedErrMsg = EditDocumentsDialogConstants.NO_FILE_UPLOADED_ERR_MSG;
    selectedFile;
    maxFileSize;
    allowedFiles = [];
    filteredAllowedFileTypes = [];
    documentUploadedBy;
    fileString;
    fileBlob;
    uploadDocumentObservableSubscripition;
    deleteUploadDocumentsObservableSubscription;
    getAttachmentContentSubscription;
    authenticatedUserSubscription;
    constructor(activeModal, appControllerService, userInformationService, requestStatusService, applicationViewService, fileUploadService, saLongDatePipe) {
        this.activeModal = activeModal;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
        this.requestStatusService = requestStatusService;
        this.applicationViewService = applicationViewService;
        this.fileUploadService = fileUploadService;
        this.saLongDatePipe = saLongDatePipe;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
        this.getAttachmentFileContent(this.documentToEdit.id);
        this.setFormValues();
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.subscribe((userInfo) => {
            this.documentUploadedBy = `${userInfo.lastName} ${userInfo.firstName}`;
        });
        this.maxFileSize = this.configUploadSettings.maximumSize;
        this.allowedFiles = this.configUploadSettings.agsSupportedAttachmentFileTypes.split(",");
        this.filteredAllowedFileTypes = FileUtils.mapAllowedFilesToMimeTypes(this.allowedFiles);
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        if (this.editDocumentForm.valid && this.uploadedFiles.length > 0) {
            try {
                this.requestStatusService.clearBusyRequestCounter();
                this.requestStatusService.showBusySpinner("save");
                this.uploadAttachment();
            }
            catch (e) {
                this.appControllerService.showMessage(EditDocumentsDialogConstants.UPLOAD_ERROR_MSG, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("save");
            }
        }
        else {
            this.markAllControlsAsTouched();
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
        this.requestStatusService.removeBusySpinner("save");
    }
    deleteAttachment(i, $event) {
        if (this.uploadedFiles.length > 0) {
            this.uploadedFiles.splice(i, 1);
            this.selectedFile = null;
            this.editDocumentForm.markAsDirty();
        }
        $event.stopPropagation();
    }
    uploadFile(files) {
        const key = "Uploading and validating files...";
        try {
            this.requestStatusService.showBusySpinner(key);
            const fileToUpload = files instanceof Event
                ? (files.target?.files?.[0] ?? null)
                : files?.[0] ?? null;
            if (!fileToUpload) {
                return;
            }
            const fileExtension = fileToUpload.name
                .substring(fileToUpload.name.lastIndexOf(".") + 1)
                .toUpperCase();
            if (!this.isFileAllowed(fileExtension)) {
                const allowedExtensions = this.allowedFiles.join(",");
                this.appControllerService.showMessage(`The file you have selected is not supported: ${fileExtension}.\n
        Please choose a different file. Only files with the following extensions are supported: ${allowedExtensions}.`, AlertType.Warning);
                return;
            }
            if (this.maxFileSize !== undefined && this.maxFileSize !== null && fileToUpload.size > this.maxFileSize) {
                this.appControllerService.showMessage(`Attached file size is ${this.bytesToSize(fileToUpload.size)} and allowed file size is ${this.bytesToSize(this.maxFileSize)}`, AlertType.Warning);
                return;
            }
            this.selectedFile = fileToUpload;
            this.uploadedFiles[0] = fileToUpload.name;
        }
        catch (error) {
            this.appControllerService.showMessage("An unexpected error occurred while uploading the file. Please try again.", AlertType.Error);
        }
        finally {
            this.requestStatusService.removeBusySpinner(key);
        }
    }
    isFileAllowed(fileExtension) {
        let isFileAllowed = false;
        this.allowedFiles.forEach(element => {
            if (element.toUpperCase() === fileExtension) {
                isFileAllowed = true;
            }
        });
        return isFileAllowed;
    }
    bytesToSize(bytes) {
        const sizes = ["Bytes", "KB", "MB", "GB"];
        if (bytes === 0)
            return "0 Byte";
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
        if (i === 0)
            return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }
    uploadAttachment() {
        this.requestStatusService.clearBusyRequestCounter();
        this.requestStatusService.showBusySpinner("upload");
        const formData = new FormData();
        formData.append("appId", this.currentApplication.appId.toString());
        formData.append("jobId", this.currentApplication.jobId.toString());
        formData.append("moduleId", this.appControllerService.selectedModuleID);
        formData.append("fileName", this.selectedFile.name);
        formData.append("description", this.editDocumentForm.get(this.descriptionFormControlName).value);
        formData.append("attachmentType", this.editDocumentForm.get(this.documentTypeFormControlName).value);
        formData.append("componentType", "Upload AFLA portal required documents");
        formData.append("aflaPortalObjectId", "0");
        formData.append("uploadedBy", this.documentUploadedBy);
        formData.append("file", this.selectedFile);
        formData.append("source", "Supplementary");
        const url = `${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_UPLOAD_ATTACHMENT_FROM_PORTAL}`;
        this.fileUploadService.uploadFile(url, formData, "portal", "Supplementary", true, (result) => {
            if (result !== null) {
                this.appControllerService.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                const attachmentObject = {
                    id: result.id,
                    type: result.attachmentType,
                    name: result.description,
                    dateUploaded: this.saLongDatePipe.transform(result.date),
                    fileName: result.fileName,
                };
                const deletedParams = {
                    ids: [this.documentToEdit.id], moduleId: this.appControllerService.selectedModuleID
                };
                this.deleteUploadDocumentsObservableSubscription = this.applicationViewService.deleteUploadDocumentsObservable(deletedParams).subscribe({
                    next: () => {
                        const resultObject = {
                            idsToDelete: [this.documentToEdit.id], editedDocument: attachmentObject
                        };
                        this.activeModal.close(resultObject);
                        this.requestStatusService.removeBusySpinner("save");
                        this.requestStatusService.removeBusySpinner("upload");
                    }, error: (error) => {
                        this.appControllerService.handleServerErrorMessage("Edit attachment modal", error, CRUDOperation.Add);
                        this.requestStatusService.removeBusySpinner("save");
                        this.requestStatusService.removeBusySpinner("upload");
                    }
                });
            }
            this.requestStatusService.showBusySpinner("upload");
        });
        this.requestStatusService.showBusySpinner("upload");
    }
    initForm() {
        this.editDocumentForm = new FormGroup({
            documentType: new FormControl(this.documentToEdit.type, Validators.required),
            description: new FormControl(this.documentToEdit.name, Validators.required),
            fileName: new FormControl(this.documentToEdit.fileName)
        });
    }
    setFormValues() {
        this.editDocumentForm.get(this.documentTypeFormControlName).setValue(this.documentToEdit.type);
        this.editDocumentForm.get(this.descriptionFormControlName).setValue(this.documentToEdit.name);
        this.uploadedFiles[0] = this.documentToEdit.fileName;
    }
    markAllControlsAsTouched() {
        Object.keys(this.editDocumentForm.controls).forEach(key => {
            if (this.editDocumentForm.get(key).invalid) {
                this.editDocumentForm.get(key).markAsTouched();
            }
        });
    }
    async getAttachmentFileContent(id) {
        const fileUrl = `${ApiAttachmentConstants.URL}/${id}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`;
        try {
            const fileBlob = await this.fileUploadService.download(fileUrl);
            const fileName = `attachment-${id}`;
            this.selectedFile = new File([fileBlob], fileName, {
                type: fileBlob.type || "application/octet-stream",
                lastModified: Date.now()
            });
            this.fileBlob = fileBlob;
        }
        catch (error) {
            this.appControllerService.handleServerErrorMessage("Edit attachment modal", error, CRUDOperation.Get);
        }
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService },
        { type: UserInformationService },
        { type: RequestStatusService },
        { type: ApplicationViewService },
        { type: FileService },
        { type: SaLongDatePipe }
    ];
    static propDecorators = {
        documentTypes: [{ type: Input }],
        dialogTitle: [{ type: Input }],
        documentToEdit: [{ type: Input }],
        configUploadSettings: [{ type: Input }],
        currentApplication: [{ type: Input }]
    };
};
EditDocumentsDialogComponent = __decorate([
    Component({
        selector: "app-edit-documents-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { "edit-documents-dialog": "view-application" },
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], EditDocumentsDialogComponent);
export { EditDocumentsDialogComponent };
